<template>
  <v-container class="payment-success-page d-flex flex-column align-center pa-0 ma-0">
    <!-- header  -->
    <v-container
      class="d-flex align-center justify-space-between py-2 px-4 border-bottom"
    >
      <v-container class="d-flex align-center pa-0 ma-0" style="width: auto">
        <v-container class="pa-0 ma-0" style="width: auto">
          <v-img
            :src="headerData.iconURL ? headerData.iconURL : require('@/assets/shopping/placeHolderImage.png')"
            height="48"
            width="48"
            class="border"
          ></v-img>
        </v-container>
        <v-container class="d-flex flex-column pa-0 ma-0 mr-3">
          <v-card-text class="text-caption pa-0 ma-0 text-grey-darken-1">
            {{ headerData.name }}
          </v-card-text>
          <v-card-text class="text-caption pa-0 ma-0 text-grey-darken-1">
            {{ headerData.desc }}
          </v-card-text>
        </v-container>
      </v-container>
      <v-container class="pa-0 ma-0" style="width: auto">
        <v-icon color="black" size="28">mdi-home-outline</v-icon>
      </v-container>
    </v-container>

    <!-- body -->
    <v-container
      class="body d-flex flex-column align-center justify-center text-center flex-grow-1 gap-4"
    >
      <img
        src="@/assets/shopping/success-3d.png"
        height="101"
        width="101"
        contain
        class=""
      />

      <!-- buy id -->
      <v-card-text class="text-body-1 pa-0 ma-0">{{ $t("thanksToBuy") }}</v-card-text>
      <v-card-text class="text-body-1 pa-0 ma-0">
        {{ $t("opertationSuccess") }}
      </v-card-text>
      <v-card-text class="text-body-1 pa-0 ma-0">
        {{ $t("order code") }}
        <v-card-text class="bold text-body-2 pa-0 ma-0">{{ successArray.id }}</v-card-text>
      </v-card-text>

      <!-- QR Code -->
      <img :src="qrCodeUrl" height="150" width="150" contain class="mb-6"/>
      <v-btn color="primary" rounded large class="new-order-btn" @click="handleReturn()">
        {{ $t("new order") }}
      </v-btn>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "PaymentSuccessPage",
  props: {
    successArray: {
      type: Object,
      required: true,
    },
    headerData: {
      type: Object,
      required: true,
    },
    shopuid: {
      type: String,
      required: true,
    },
  },
  computed: {
    qrCodeUrl() {
      const link = `https://abr.abriron.com/print/invoice/${this.successArray.uid}?cuid=${this.shopuid}`;
      return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
        link
      )}&size=150x150`;
    },
  },
  methods: {
    handleReturn() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.payment-success-page {
  direction: rtl;
  height: 100vh;
}

.header {
  height: 70px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
}
.home-icon {
  color: #333;
  font-size: 26px;
  cursor: pointer;
}
.shop-info {
  flex: 1;
}
.shop-title {
  font-size: 15px;
  color: #1a1a1a;
}
.shop-subtitle {
  font-size: 13px;
  color: #808080;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
}
.subtitle {
  font-size: 15px;
  color: #444;
}
.success-text {
  color: #28a745;
  font-weight: 600;
}
.order-code {
  font-size: 14px;
  color: #1a1a1a;
}
.bold {
  font-weight: bold;
}
.success-icon {
  border-radius: 50%;
  background-color: #e6ffee;
  padding: 16px;
}

.new-order-btn {
  font-weight: 600;
  font-size: 14px;
  width: 220px;
  height: 45px;
}
/* .container {
  width: auto;
} */
</style>
